import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "flex flex-row items-center justify-between mt-3 px-6",
  style: {"border-bottom":"1px solid rgba(224, 224, 224, 1)","padding-bottom":"15px"},
  "data-testid": "handover-scan-revamp-header"
}
const _hoisted_2 = { class: "text-xl text-black-lp-200 font-semibold" }
const _hoisted_3 = {
  "data-testid": "dex-reconcile-scan-rekon-page",
  class: "flex flex-grow min-h-0 min-w-0 gap-3 p-3 bg-gray-lp-1200"
}
const _hoisted_4 = { class: "flex-grow flex flex-col min-h-0 min-w-0 gap-y-2" }
const _hoisted_5 = { class: "flex-grow-0 flex flex-col min-h-0 overflow-y-auto gap-4 bg-white relative" }
const _hoisted_6 = { "data-testid": "dex-reconcile-scan-rekon-region-top" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col gap-4",
  "data-testid": "dex-reconcile-scan-rekon-region-results"
}
const _hoisted_8 = {
  "data-testid": "dex-reconcile-scan-rekon-region-sidebar",
  class: "w-80 flex-shrink-0 flex flex-col gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScanPanel = _resolveComponent("ScanPanel")!
  const _component_ScanResultsFilter = _resolveComponent("ScanResultsFilter")!
  const _component_ScanResultsTable = _resolveComponent("ScanResultsTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ScanSidebarEntityPanel = _resolveComponent("ScanSidebarEntityPanel")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Card, {
          class: "p-4 gap-y-4 flex-grow flex flex-col min-h-0",
          rounded: "xl",
          isShadow: false,
          style: {"max-height":"max-content"}
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_ScanPanel, {
                  modelValue: _ctx.sttNoInputValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sttNoInputValue = $event)),
                  isScanning: _ctx.isScanning,
                  isDuplicateScan: _ctx.isDuplicateScan,
                  lastScanRow: _ctx.lastScanRow,
                  failedScans: _ctx.failedScans,
                  onEnter: _ctx.onScanEnter
                }, null, 8, ["modelValue", "isScanning", "isDuplicateScan", "lastScanRow", "failedScans", "onEnter"])
              ]),
              (_ctx.allDraftScanList.items.length || _ctx.isLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode(_component_ScanResultsFilter, {
                      modelValue: _ctx.resultsPanel.filters,
                      "onUpdate:modelValue": [
                        _cache[2] || (_cache[2] = ($event: any) => (_ctx.resultsPanel.filters = $event)),
                        _ctx.onFiltersUpdate
                      ],
                      rows: _ctx.allDraftScanList.items
                    }, null, 8, ["modelValue", "rows", "onUpdate:modelValue"]),
                    _createVNode(_component_ScanResultsTable, {
                      rows: _ctx.draftScanDataTable.items,
                      isLoading: _ctx.isLoading,
                      onDelete: _ctx.onDeleteRow
                    }, null, 8, ["rows", "isLoading", "onDelete"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_ScanSidebarEntityPanel, {
          isEmpty: !_ctx.allDraftScanList.items.length,
          isLoading: _ctx.isLoading,
          lastScanRow: _ctx.lastScanRow,
          "onUpdate:lastScanRow": _cache[3] || (_cache[3] = ($event: any) => (_ctx.lastScanRow = $event)),
          rows: _ctx.allDraftScanList.items,
          eligibleVendorList: _ctx.eligibleVendorList,
          onProcess: _ctx.onConfirmProcessHandover,
          onClearAll: _ctx.onClearAll
        }, null, 8, ["isEmpty", "isLoading", "lastScanRow", "rows", "eligibleVendorList", "onProcess", "onClearAll"])
      ])
    ])
  ], 64))
}